import { render, staticRenderFns } from "./ApplicationSetup.vue?vue&type=template&id=6dd6d798&scoped=true&"
import script from "./ApplicationSetup.vue?vue&type=script&lang=js&"
export * from "./ApplicationSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd6d798",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideYReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSlideYReverseTransition})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dd6d798')) {
      api.createRecord('6dd6d798', component.options)
    } else {
      api.reload('6dd6d798', component.options)
    }
    module.hot.accept("./ApplicationSetup.vue?vue&type=template&id=6dd6d798&scoped=true&", function () {
      api.rerender('6dd6d798', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/components/Application/Setup/ApplicationSetup.vue"
export default component.exports